import {tokens} from '@pleo-io/telescope'
import GithubSlugger from 'github-slugger'
import React from 'react'
import styled from 'styled-components'

import {Text} from '@helios/shared/styles/typography'
import mq from '@helios/shared/utils/media-query'

import {colors, radii} from '../../theme'

export type CalloutProps = {
    title: string
    label?: string
    Icon?: React.ComponentType<any>
    Image?: React.ComponentType<any>
    RichText: React.ComponentType<any>
}

const imgDimension = 180
const iconDimension = 28

export const Callout = ({title, label, RichText, Icon, Image}: CalloutProps) => {
    const slugger = new GithubSlugger()
    const slug = slugger.slug(title)

    return (
        <Wrapper aria-labelledby={slug}>
            {Image && <StyledImage as={Image} style={{height: imgDimension}} />}

            <ContentWrapper>
                {!Image && (
                    <IconTitleWrapper>
                        {Icon && <StyledIcon as={Icon} aria-hidden />}

                        <Text id={slug} variant="paragraph-base">
                            {title}
                        </Text>
                    </IconTitleWrapper>
                )}

                <BodyLabelWrapper>
                    <RichText color="muted" />
                    {label && (
                        <Text variant="paragraph-base" color="lightMuted">
                            {label}
                        </Text>
                    )}
                </BodyLabelWrapper>
            </ContentWrapper>
        </Wrapper>
    )
}

const MOBILE_BREAKPOINT = 'sm'

const Wrapper = styled.aside`
    display: grid;
    row-gap: ${tokens.spacing20};
    padding: ${tokens.spacing20};
    background: ${colors.background.muted};
    border-radius: ${radii.arc8};

    ${mq.min(MOBILE_BREAKPOINT)} {
        grid-template-columns: auto 1fr;
        column-gap: ${tokens.spacing40};
        align-items: center;
        padding: ${tokens.spacing40};
        border-radius: ${radii.arc20};
    }
`

const IconTitleWrapper = styled.div`
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    justify-content: start;
    column-gap: ${tokens.spacing12};
`

const BodyLabelWrapper = styled.div`
    display: grid;
    row-gap: ${tokens.spacing16};
`

const StyledIcon = styled.img`
    width: ${iconDimension}px;
    height: ${iconDimension}px;
    object-fit: contain;
`

const StyledImage = styled.img`
    width: ${imgDimension}px;
    height: ${imgDimension}px;
    object-fit: cover;
    object-position: center;
    border-radius: ${radii.circle};
    justify-self: center;

    ${mq.min(MOBILE_BREAKPOINT)} {
        justify-self: start;
    }
`

const ContentWrapper = styled.div`
    display: grid;
    row-gap: ${tokens.spacing8};
`
